import { createContext, useContext } from "react";

/// Whether the sidebar rail is expanded, so a page can leave out what the open
/// rail already shows. Without a provider the rail counts as collapsed.
export const RailOpenContext = createContext(false);

export const useRailOpen = (): boolean => useContext(RailOpenContext);
